import { Emissor, Portal } from 'enum';
import React, { createContext, useMemo, useState } from 'react';
import { ContentMainType } from 'types';

type PropsMainContext = {
  state: ContentMainType;
  setState: React.Dispatch<React.SetStateAction<ContentMainType>>;
};

interface DefaultProps {
  children: React.ReactNode;
}

const DEFAULT_VALUE: PropsMainContext = {
  state: {
    emissor: Emissor.VRPAT,
    portal: Portal.RH,
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setState: () => {},
};

const MainContext = createContext<PropsMainContext>({} as PropsMainContext);

const MainContextProvider: React.FC<DefaultProps> = ({ children }) => {
  const [state, setState] = useState(DEFAULT_VALUE.state);

  const memo = useMemo(() => ({ state, setState }), [state]);

  return <MainContext.Provider value={memo}>{children}</MainContext.Provider>;
};
export { MainContextProvider };

export default MainContext;
